/**
 * CalendarEventListItem
 */
import React from 'react';
import { Link as LinkBase } from 'ui-component-library/base';
import clsx from 'clsx';
/** Naviagation list with links. */
var CalendarEventListItem = function (_a) {
    var heading = _a.heading, text = _a.text, category = _a.category, _b = _a.url, url = _b === void 0 ? '#' : _b, startDay = _a.startDay, endDay = _a.endDay, startMonth = _a.startMonth, endMonth = _a.endMonth, hasEndDate = _a.hasEndDate, _c = _a.headingLevel, headingLevel = _c === void 0 ? 'h2' : _c, _d = _a.LinkComponent, LinkComponent = _d === void 0 ? LinkBase : _d;
    var Heading = headingLevel;
    var Link = LinkComponent;
    return (React.createElement("article", { "data-cid": "CalendarEventListItem" },
        React.createElement(Link, { to: url, className: "flex pb-4 mb-4 no-underline border-b-borderWidth border-borderColor group" },
            React.createElement("div", { className: clsx(hasEndDate ? 'min-w-24' : 'min-w-14', 'text-calendarEventList-text-color mr-3 flex') },
                React.createElement("p", { className: "text-p" },
                    React.createElement("span", { className: 'block text-h2' }, startDay),
                    React.createElement("span", { className: 'block text-p' }, startMonth)),
                endDay !== startDay && React.createElement("span", { className: 'text-h2 mx-1' }, "-"),
                React.createElement("p", { className: "text-p" },
                    endDay !== startDay && (React.createElement("span", { className: 'block text-h2' }, endDay)),
                    endMonth !== startMonth && endDay && (React.createElement("span", { className: 'block text-p' }, endMonth)))),
            React.createElement("div", null,
                React.createElement(Heading, { className: "mt-0 mb-1 text-h3 text-primary-2 font-fontWeightLink group-hover:underline" }, heading),
                React.createElement("p", { className: "text-p text-greyDarker" }, category),
                React.createElement("p", { className: "text-p text-black" }, text)))));
};
export default CalendarEventListItem;
